import { createContext, useContext } from "react";

const STRINGS = {
  "nav.home": "Home", "nav.talent": "Talent", "nav.about": "About",
  "nav.services": "Services",
  "nav.apply": "Get Scouted", "nav.faq": "FAQ", "nav.contact": "Contact",
  "common.viewTalent": "View Talent", "common.becomeModel": "Get Scouted",
  "common.contactUs": "Contact Us",
  "common.applyNow": "Apply Now", "common.readMore": "Read more",
  "common.followUs": "Follow us", "common.subscribe": "Subscribe",
  "hero.tagline": "Model Management · Rotterdam",
  "hero.subtitle": "Scouting and developing the next generation of editorial talent.",
  "hero.est": "Est. 2026 — Rotterdam, NL",
  "footer.tagline": "model management,",
  "footer.tagline2": "Rotterdam, Netherlands.",
  "footer.about": "Ege Models is a model management agency based in Rotterdam, the Netherlands. We scout, develop and represent the next generation of high-fashion talent.",
  "footer.navigate": "Navigate", "footer.apply": "Get Scouted", "footer.reachUs": "Reach Us",
  "footer.privacy": "Privacy", "footer.terms": "Terms",
};

const LanguageContext = createContext({ t: (k) => k });

export function LanguageProvider({ children }) {
  const t = (k) => STRINGS[k] ?? k;
  return <LanguageContext.Provider value={{ t }}>{children}</LanguageContext.Provider>;
}

export function useTranslation() { return useContext(LanguageContext); }
